'use client'

import { Tooltip, TooltipTrigger, Link } from 'react-aria-components'
import Icon from '@/components/ui/icon'

type GridViewLinkProps = {
  tooltipText: string
  link: string
  iconId: string
  className?: string
  direction?: 'next' | 'previous'
}

export function GridViewLink({
  tooltipText,
  link,
  iconId,
  direction = 'next',
  className = '',
}: GridViewLinkProps) {
  return (
    <TooltipTrigger delay={0}>
      <Link href={link} className={`group inline-flex items-center ${className}`}>
        {direction === 'previous' ? (
          <Icon
            id="icon-chevron-left"
            width={18}
            height={18}
            className="text-black group-hover:text-primary"
          />
        ) : null}

        <Icon id={iconId} width={24} height={24} className="text-black group-hover:text-primary" />

        {direction === 'next' ? (
          <Icon
            id="icon-chevron-right"
            width={18}
            height={18}
            className="text-black group-hover:text-primary"
          />
        ) : null}
      </Link>

      {tooltipText ? <Tooltip>{tooltipText}</Tooltip> : null}
    </TooltipTrigger>
  )
}
